import { useEffect } from "react";
import { Settings } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useQueryState } from "nuqs";
import { useSettingsStore } from "./store/useSettingsStore";
import { SettingsTab } from "./types/settings.types";
import SettingsTabBar from "./components/SettingsTabBar";
import GmailBanksTab from "./components/GmailBanksTab";
import ApiKeysTab from "./components/ApiKeysTab";
import MerchantAliasesTab from "./components/MerchantAliasesTab";
import PaymentProfilesTab from "./components/PaymentProfilesTab";

export default function SettingsPage() {
  const loadAll = useSettingsStore((s) => s.loadAll);

  const [tab, setTab] = useQueryState<SettingsTab>("tab", {
    defaultValue: SettingsTab.Gmail,
    parse: (v: string): SettingsTab =>
      Object.values(SettingsTab).includes(v as SettingsTab)
        ? (v as SettingsTab)
        : SettingsTab.Gmail,
  });

  // Split Groups moved to /friends; keep old links working.
  const [rawTab] = useQueryState("tab");

  useEffect(() => {
    loadAll();
  }, []);

  if (rawTab === "split-groups") {
    return <Navigate to="/friends?tab=groups" replace />;
  }

  return (
    <>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-9 h-9 shrink-0 rounded-xl bg-primary/10 flex items-center justify-center">
          <Settings className="w-5 h-5 text-primary" />
        </div>
        <div className="min-w-0">
          <h1 className="text-xl font-bold text-foreground">Settings</h1>
          <p className="text-sm text-muted-foreground">
            Gmail import, bank configuration, API keys, and payment details
          </p>
        </div>
      </div>

      <SettingsTabBar tab={tab} onSelect={setTab} />

      {tab === SettingsTab.Gmail && <GmailBanksTab />}
      {tab === SettingsTab.ApiKeys && <ApiKeysTab />}
      {tab === SettingsTab.MerchantAliases && <MerchantAliasesTab />}
      {tab === SettingsTab.PaymentDetails && <PaymentProfilesTab />}
    </>
  );
}
